export const FollowUpMessage = {
  FamilyList: {
    Title: 'フォローアップ・メッセージ',
  },
  Thread: {
    NoThread: '現在、フォローアップ・メッセージはありません。',
    Spacer: '　|　',
  },
  Message: {
    SendDialog:
      '一度送信すると再送信できません。送信内容に間違いはないでしょうか。',
    SendBtn: '送信',
    SubmitBtn: '送信する',
    CancelBtn: 'キャンセル',
    Placeholder: 'メッセージを入力',
    UpdateMessage: 'メッセージ更新',
    ChoosePharmacy: 'メッセージを送信する薬局を選択してください',
    Answer: '回答する',
    PainStart: '0：痛みなし　　',
    PainEnd: '10：最悪の痛み',
    SelectTemplate: 'テンプレートから選ぶ',
    SendDialogNoLimit: '送信内容に間違いはないでしょうか。',
  },
  Tab: {
    Pharmacy: '薬局',
    Corporation: '健康サポート',
  },
};
